import _ from 'underscore';
import { Decorator } from './decorator';

export class SegmentationDecorator extends Decorator {
  /**
   * Creates an instance of SegmentationDecorator.
   * @param {Object} options [{
   *  featureName: Name of feature, such as "PerformanceGrid",
   *  isOdataActionSource = false,
   *  deps: Legacy dependencies
   *  deps.SegmentationPreference: from 'component/bingads-grid/service/segmentation-preferences'
   *  }={}]
   * @memberof SegmentationDecorator
   */
  constructor({ featureName, isOdataActionSource = false, deps }) {
    super({ name: 'segment', deps, expectedDeps: ['SegmentationPreference'] });

    this.getSegType = deps.SegmentationPreference.getSegType;
    this.getSegPreference = deps.SegmentationPreference.getSegPreference;

    this.featureName = featureName;
    this.isOdataActionSource = isOdataActionSource;
  }

  addSegmentToEntity(queryParams, segType) {
    /* eslint-disable no-param-reassign */
    queryParams.gridDataParameters =
      segType && segType !== 'None'
        ? _.defaults(
          { SegmentationTypes: [segType] },
          queryParams.gridDataParameters
        )
        : _.omit(queryParams.gridDataParameters, 'SegmentationTypes');

    return queryParams;
  }

  addSegmentToQuery(queryParams, segType) {
    const newQuery =
      segType && segType !== 'None'
        ? _.defaults({ SegmentationTypes: segType }, queryParams.query)
        : _.omit(queryParams.query, 'SegmentationTypes');

    return _.defaults(
      {
        query: newQuery,
      },
      queryParams
    );
  }

  getValueAsync() {
    return this.getSegPreference(this.featureName).then(() =>
      this.getSegType(this.featureName));
  }

  buildQuery(queryParams, segType) {
    const segmentationType = segType ? segType.segmentationType : undefined;

    let transformedQueryParams = this.addSegmentToQuery(
      queryParams,
      segmentationType
    );

    if (this.isOdataActionSource) {
      transformedQueryParams = this.addSegmentToEntity(
        transformedQueryParams,
        segmentationType
      );
    }
    return transformedQueryParams;
  }
}
